module.exports = __webpack_public_path__ + "img/metro_L9S.c3713fa4.svg";